import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const
  Banners = lazy(() => import('../../../views/Banners/index'))


const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`${props.match.path}/admin`} component={Banners} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
